import { Box, LinearProgress, LinearProgressProps, Stack, Typography } from '@mui/material';
import { ProgressStatus } from '../types';

export const processStatusConfig = {
  [ProgressStatus.RUNNING]: {
    label: 'Uploading',
    color: 'info.main',
  },
  [ProgressStatus.COMPLETED]: {
    label: 'Uploaded',
    color: 'success.main',
  },
};

const LinearProgressWithLabel = (props: LinearProgressProps & { value: number; status: ProgressStatus }) => {
  return (
    <Stack direction="column" spacing={1} sx={{ display: 'flex', flex: 1 }}>
      <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
        <Typography variant="body1">{processStatusConfig[props.status].label}</Typography>
        <Typography variant="body1">{`${Math.round(props.value)}%`}</Typography>
      </Stack>
      <Box width="100%" sx={{ color: processStatusConfig[props.status].color }}>
        <LinearProgress variant="determinate" color="inherit" {...props} />
      </Box>
    </Stack>
  );
};

export default LinearProgressWithLabel;
